import { render, staticRenderFns } from "./contents.vue?vue&type=template&id=51065662&scoped=true&"
import script from "./contents.vue?vue&type=script&lang=js&"
export * from "./contents.vue?vue&type=script&lang=js&"
import style0 from "./contents.vue?vue&type=style&index=0&id=51065662&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51065662",
  null
  
)

export default component.exports